import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    senha: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Simular login (substitua por chamada real da API)
      if (formData.email === 'cliente@unet.com.br' && formData.senha === '123456') {
        const userData = {
          id: 1,
          nome: 'João Silva',
          email: formData.email,
          plano: 'PREMIUM 600 MB',
          status: 'Ativo',
          vencimento: '15/02/2025'
        };

        localStorage.setItem('unet_token', 'token_simulado_123');
        localStorage.setItem('unet_user', JSON.stringify(userData));
        
        navigate('/central');
      } else {
        setError('Email ou senha incorretos');
      }
    } catch (err) {
      setError('Erro ao fazer login. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="container">
        <div className="login-container">
          <div className="login-header">
            <h1>Central do Assinante</h1>
            <p>Faça login para acessar sua conta</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="error-message">{error}</div>}
            
            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Seu e-mail"
              />
            </div>

            <div className="form-group">
              <label htmlFor="senha">Senha</label>
              <input
                type="password"
                id="senha"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                required
                placeholder="Sua senha"
              />
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <div className="login-footer">
            <p>Não tem uma conta? <a href="/cadastro">Cadastre-se</a></p>
            <p><a href="/central/esqueci-senha">Esqueci minha senha</a></p>
          </div>

          <div className="login-demo">
            <h3>Dados para teste:</h3>
            <p><strong>E-mail:</strong> cliente@unet.com.br</p>
            <p><strong>Senha:</strong> 123456</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login; 